const initualState = {
    Total_Number_Of_Registered_Employees: "",
    Total_Number_Of_Funded_Employees: "",
    Total_Number_Of_UnFunded_Employees: "",
    Total_Amount_Remitted_To_Date: "",
    Employer_Name : ''
  };
  
  export default (state = initualState, action) => {
    switch (action.type) {
      case "GET_EMPLOYER_DATA":
        return { ...state, employerData: action.payload };
      default:
        return state;
    }
  };
  